import React from 'react';
import { useAuth } from '@context/auth/base';
import { useGetNotified } from '../useGetNotified';
import { DefaultButton } from './variants/Default';
import { IconButton } from './variants/Icon';
import { UpcomingDropButton } from './variants/UpcomingDrop';

type GetNotifiedButtonProps = {
  type:
    | 'upcoming_drop'
    | 'feed_release_card'
    | 'landing_hero'
    | 'mint_component'
    | 'new_profile_action_bar'
    | 'icon_button'
    | 'default';
  userId: string;
  artistId: string;
  dark?: boolean;
  filled?: boolean;
};

export function GetNotifiedButton({ type, artistId, userId, dark }: GetNotifiedButtonProps) {
  const { authUser } = useAuth();
  const isOwner = authUser?.id === userId;
  const { loading, showSubscribed, handleClick } = useGetNotified({
    artistId,
    userId,
  });

  const defaultButton = (
    <DefaultButton
      dark={dark}
      loading={loading}
      onClick={handleClick}
      showSubscribed={showSubscribed}
      isOwner={isOwner}
    />
  );

  switch (type) {
    case 'upcoming_drop':
      return (
        <UpcomingDropButton
          loading={loading}
          showSubscribed={showSubscribed}
          onClick={handleClick}
          isOwner={isOwner}
        />
      );
    case 'feed_release_card':
      return <div className="mt-4 md:mt-0">{defaultButton}</div>;
    case 'landing_hero':
      return <div className="ml-auto md:ml-0 md:mt-4">{defaultButton}</div>;
    case 'mint_component':
      return (
        <DefaultButton
          dark={dark}
          loading={loading}
          onClick={handleClick}
          showSubscribed={showSubscribed}
          isOwner={isOwner}
          noMaxWidth
        />
      );
    case 'new_profile_action_bar':
      return (
        <IconButton
          onClick={handleClick}
          showSubscribed={showSubscribed}
          className="h-9 w-9 p-3 md:h-10 md:w-10"
          isOwner={isOwner}
        />
      );
    case 'icon_button':
      return <IconButton onClick={handleClick} showSubscribed={showSubscribed} isOwner={isOwner} />;

    case 'default':
      return defaultButton;
  }
}
